import script from "./Receivables.vue?vue&type=script&setup=true&lang=js"
export * from "./Receivables.vue?vue&type=script&setup=true&lang=js"

import "./Receivables.vue?vue&type=style&index=0&id=0072ed86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0072ed86"]])

export default __exports__